import { Banner } from '@/components/contact'
import { Container } from '@/components/container'
import { useTranslation } from '@/utils/hook'

const Contact = (): JSX.Element => {
  const t = useTranslation()

  return (
    <Container
      url="/contact"
      title={t('metadata.contact.title')}
      description={t('metadata.contact.description')}
    >
      <Banner />
    </Container>
  )
}

export default Contact
